import * as React from 'react';
import styled from 'styled-components';

import { Icon } from '@creditornot/alchemy-react';
import * as icons from '@creditornot/alchemy-react/icons';
import { color } from '@creditornot/cb-ingredients/design-tokens';
import { Stack } from 'common/components/cookbook/Stack';
import { Typography as T } from 'common/components/cookbook/Typography/Typography';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const Root = styled.div`
  padding: 32px;
  text-align: center;
  color: ${color.textSubdued};
`;

const IconContainer = styled.div`
  margin-bottom: 12px;
`;

type Props = {
  isSearchingByGtin: boolean;
  filterApplied?: boolean;
};

export const NoItemsFoundLegacy: React.FC<Props> = ({ isSearchingByGtin, filterApplied }) => {
  const formatMessage = useFormatMessage();

  return (
    <Root>
      <IconContainer>
        <Icon source={icons.magnifyingGlass} size="medium" fill={color.textSubdued} />
      </IconContainer>
      <Stack direction="column" alignItems="center" justifyContent="center" gap="regularMedium">
        <T.subheadline>
          {isSearchingByGtin
            ? formatMessage('warehouse.common.no_items_found_with_the_scanned_code')
            : formatMessage('warehouse.common.no_items_found')}
        </T.subheadline>
        <T.caption>
          {filterApplied
            ? formatMessage('warehouse.common.no_items_found_helper_text_with_filter')
            : formatMessage('warehouse.common.no_items_found_helper_text')}
        </T.caption>
      </Stack>
    </Root>
  );
};
